module.exports = __webpack_public_path__ + "img/bg-flow.e63de190.jpg";